module.exports = __webpack_public_path__ + "img/login_1.ead282ea.png";